import imageDe from '../images/de/kanta_identification.png';
import imageEn from '../images/en/kanta_identification.png';
import imageEs from '../images/es/kanta_identification.png';
import imageFi from '../images/fi/kanta_identification.png';
import imageFr from '../images/fr/kanta_identification.png';
import imageIt from '../images/it/kanta_identification.png';
import imageNo from '../images/no/kanta_identification.png';
import imageSv from '../images/sv/kanta_identification.png';

export const kantaIdentificationImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
